import { useRows } from '@/hooks/useLive';
import { useConcreteAccess } from '@/lib/concrete';
import type { Site } from '@/types/models';
import { siteRuns } from '@/lib/operations';

/** The concrete branches (0062: those running concrete) this user works with: their own, or all of them for quarry
 *  management. Read from the local mirror so it works offline. */
export function useBranches(): Site[] {
  const sites = useRows<Site>('sites', 'name');
  const access = useConcreteAccess();
  return (sites ?? []).filter((s) =>
    s.kind === 'branch' && siteRuns(s, 'concrete') && s.is_active && !s.deleted_at && access.canView(s.id));
}
